import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { toYesOrNo } from '../../../../../../utils/helpers.utils';
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";

export class WirelineOtherDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    render() {
        const { data } = this.props;
        console.log('data', data.BusinessWireline)
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" /></h4>
                <div className="order-detail-location">
                    <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="order_number" /></td>
                                <td>{data.Order.OrderNumber}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="subscription_number" /></td>
                                <td>{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.PlanDetails.PlanName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.VendorName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.SimType.SimTypeName}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="other_request_details" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="other_request_type" /></td>
                                <td>{data.Order.RequestType.RequestType}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="approver" /></td>
                                <td>{data.BusinessWireline.WirelineApproverName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="local_contact_email_address" /></td>
                                <td>{data.BusinessWireline.LocalContactEmail}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="local_contact_fullname" /></td>
                                <td>{data.BusinessWireline.LocalContactFullName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="local_contact_phone_number" /></td>
                                <td>{data.BusinessWireline.LocalContactPhone}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="alt_local_contact_email_address" /></td>
                                <td>{data.BusinessWireline.AltLocalContactEmail}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="alt_local_contact_full_name" /></td>
                                <td>{data.BusinessWireline.AltLocalContactFullName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="alt_local_contact_phone_number" /></td>
                                <td>{data.BusinessWireline.AltLocalContactPhone}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="expedite_request" /></td>
                                <td>{toYesOrNo(data.BusinessWireline.ExpediteRequest)}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>

                        </tbody>
                    </Table>
                    <OrderRequestFiles files={data.Order.OrderFileNames} />
                </div>
            </div>
        );
    }
}